/*
 * @Author: Fan
 * @Date: 2020-04-13 17:06:58
 * @LastEditTime: 2020-04-27 22:06:41
 * @LastEditors: Fan
 * @Description:
 * @FilePath: /frontend/modules/@cloudpivot/form/src/components/ShortText/setting.ts
 */
import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import { formatterRequiredFormula, formatterValueToSetStatus } from "../../../../form/utils";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"]
        },
        controller: {
            label: "控件属性",
            keys: [
                "defaultValue",
                "readonlyFormula",
                "placeholder",
                "isScan",
                "requiredFormula",
                "dataLinkage"
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.ShortText').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.ShortText').toString() }),
        dictionaryData: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/dictionary-setting.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 显示条件
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
                callback: (key, attr, attrs, vm) => {
                    if (attr.value === 'true') {
                        const readonlyFormula = attrs.find((a) => a.field === "readonlyFormula");
                        //attrs是数据项规则数据，所以无法找到控件属性中的readonlyFormula，这段代码有问题
                        if (readonlyFormula && readonlyFormula.value) {
                            vm.updateAttribute(key, "readonlyFormula", 'false');
                        }
                    }
                },
            },
        },
        // 只读条件
        readonlyCondition: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "readonlyCondition",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 默认值
        defaultValue: {
            options: {
                regexps: {
                    maxLength: {
                        len: 2000,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 2000 }).toString(),
                    },
                },
            },
        },
        // 正则校验
        regexp: {
            inputMethod: ControlAttributeType.Modal,
            attrType: "regularModal",
            inputComponent: () => import("../../../../form/src/common/components/regular-modal2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        //正则错误提示
        regexpText: {
            options: {
                regexps: {
                    maxLength: {
                        len: 2000,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 2000 }).toString(),
                    },
                },
            },
        },
        // 提示文字
        placeholder: {
            options: {
                regexps: {
                    maxLength: {
                        len: 2000,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 2000 }).toString(),
                    },
                },
            },
        },
        // 文本最大长度
        maxLength: {
            options: {
                regexps: {
                    // required: "最大长度不能为空",
                    regexps: [
                        {
                            regexp: /^[1-9]\d*$/,
                            message: i18n.t('dataitem.ValidityErrTips2').toString(),
                        },
                        {
                            regexp: (value) => parseFloat(value) <= 2000,
                            message: i18n.t('dataitem.ValidityErrTips3', { num: 2000 }).toString(),
                        },
                    ],
                },
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/data-linkage2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        shortTextStitch: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/short-text-rouls.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
    },
};
